import BaseController from "controllers/backend/base"

import ResultsFilterWidget from "widgets/backend/resultsFilterWidget"

class Controller extends BaseController {
  call() {
    super.call()

    bindResultsFilter.call(this)
    // bindCheckAllCheckbox.call(this)
  }
};

const bindResultsFilter = function() {
  let elem = this.root
  this.resultsFilter = new ResultsFilterWidget(elem)
}

// const bindCheckAllCheckbox = function() {
//   this.root.on('.check_all_group').on("click", (e) => {
//     if (e.target.name === 'All') {
//       let checkboxes = document.getElementsByName('group');
//       for (var i=0, n = checkboxes.length; i < n; i++) {
//         checkboxes[i].checked = document.querySelector('.check_all_group').checked;
//       }
//     }
//   })
// }

export default Controller;
